import { render, staticRenderFns } from "./TeamOne.vue?vue&type=template&id=1778a349&scoped=true&lang=pug&"
import script from "./TeamOne.vue?vue&type=script&lang=js&"
export * from "./TeamOne.vue?vue&type=script&lang=js&"
import style0 from "./TeamOne.vue?vue&type=style&index=0&id=1778a349&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1778a349",
  null
  
)

export default component.exports